import script from "./StatementGeneratorPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementGeneratorPanel.vue?vue&type=script&setup=true&lang=js"

import "./StatementGeneratorPanel.vue?vue&type=style&index=0&id=3f9b7464&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f9b7464"]])

export default __exports__